import { render, staticRenderFns } from "./updateDocumentConfig.vue?vue&type=template&id=9dc7c5b2&"
import script from "./updateDocumentConfig.vue?vue&type=script&lang=js&"
export * from "./updateDocumentConfig.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports